/**
 * Kid PINs are 4–6 digits. The PIN pad never knows a kid's PIN length (an unauthenticated
 * device mustn't learn it), so it takes up to PIN_MAX digits and submits on "Go" once at least
 * PIN_MIN are in.
 */

export const PIN_MIN = 4;
export const PIN_MAX = 6;
export const PIN_PATTERN = new RegExp(`^\\d{${PIN_MIN},${PIN_MAX}}$`);
export const PIN_RULE = `PIN must be ${PIN_MIN}–${PIN_MAX} digits`;

export const isValidPin = (pin: string) => PIN_PATTERN.test(pin);

export type PinKey = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "delete" | "go";

/** The PIN after a key press, and whether that press submits it. */
export function pressPinKey(pin: string, key: PinKey): { pin: string; submit: boolean } {
  if (key === "delete") return { pin: pin.slice(0, -1), submit: false };
  if (key === "go") return { pin, submit: isValidPin(pin) };
  return { pin: pin.length < PIN_MAX ? pin + key : pin, submit: false };
}
